import React from "react";
import { useTranslation } from "react-i18next";
import TitleSubtitle from "../../components/common/TitleSubtitle";
import TextInput from "../../components/ui/TextInput";
import Icon from "../../components/common/Icon";
import { getPurchaseInfo } from "../../api/support";
import { GetOtpTokenResponse } from "../../types/types";
import adminSurface from "../../components/layouts/AdminSurface.module.css";
import studio from "../../styles/studioPage.module.css";

const ReservationHistory: React.FC = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const [reservationId, setReservationId] = React.useState<string>("");
    const [loading, setLoading] = React.useState<boolean>(false);
    const [purchaseInfos, setPurchaseInfos] = React.useState<GetOtpTokenResponse | null>(null);

    const getReservationHistory = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                console.error("Token not found");
                return;
            }

            if (!reservationId) {
                console.error("Reservation ID is required");
                return;
            }
            const purchaseInfos = await getPurchaseInfo(token, reservationId);
            setPurchaseInfos(purchaseInfos);
        } catch (error) {
            console.error("Failed to fetch reservation history", error);
        } finally {
            setLoading(false);
        }
    };

    const BoolIcon = ({ ok }: { ok: boolean }) => (
        <Icon
            name={ok ? "ic-check" : "ic-x"}
            className={`ic ${adminSurface.supportBool} ${ok ? adminSurface.supportBoolYes : adminSurface.supportBoolNo}`}
            size={22}
        />
    );

    return (
        <div className={adminSurface.pageContent}>
            <div className={`${studio.pageTitle} ${adminSurface.pageTitle}`}>
                <TitleSubtitle title={t("reservationHistory")} subtitle={t("reservationHistorySubTitle")} />
            </div>

            <div className={adminSurface.supportLiWrap}>
                <TextInput
                    placeholder={t("reservationHistory")}
                    onChange={(e) => setReservationId(e.target.value)}
                    value={reservationId}
                    disabled={loading}
                />
            </div>

            <div className={adminSurface.supportLiActions}>
                <button
                    onClick={() => getReservationHistory()}
                    className={adminSurface.addButton}
                    disabled={!reservationId}
                >
                    {t("reservationHistoryButton")}
                </button>
            </div>

            <h2 className={adminSurface.supportRowsTitle}>{t("otpTokenInfo")}</h2>
            <div
                className={`${adminSurface.tableContainer} ${adminSurface.tblScrollSupport} ${adminSurface.supportScrollX}`}
            >
                <table className={adminSurface.table}>
                    <thead>
                        <tr>
                            <th>{t("tokenExists")}</th>
                            <th>{t("tokenClaimed")}</th>
                            <th>{t("activationCount")}</th>
                            <th>{t("purchaseExists")}</th>
                            <th>{t("purchaseConsumed")}</th>
                            <th>{t("businessCatalog")}</th>
                            <th>{t("user")}</th>
                            <th>{t("created")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <BoolIcon ok={!!purchaseInfos?.otpToken} />
                            </td>
                            <td>
                                <BoolIcon ok={!!purchaseInfos?.otpToken?.claimed} />
                            </td>
                            <td>{purchaseInfos?.otpToken?.activation ?? "-"}</td>
                            <td>
                                <BoolIcon ok={!!purchaseInfos?.purchase} />
                            </td>
                            <td>
                                <BoolIcon ok={!!purchaseInfos?.purchase?.consumed} />
                            </td>
                            <td>{purchaseInfos?.otpToken?.businessCatalogId ?? "-"}</td>
                            <td>{purchaseInfos?.otpToken?.userBId ?? "-"}</td>
                            <td>{purchaseInfos?.otpToken?.createdAt ?? "-"}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ReservationHistory;
